import script from "./AppLayoutAuthorized.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLayoutAuthorized.vue?vue&type=script&setup=true&lang=ts"

import "./AppLayoutAuthorized.vue?vue&type=style&index=0&id=6aee5d28&lang=css&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Web.API\\client-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aee5d28"]])

export default __exports__